//Users
$(document).on('click','.nuevoUserModal', function(){
    $("#_method").val("POST");
    $("#formUser").attr('action',"users");
    $("#fichaUserLabel").html("Creación de nuevo usuario");
    $(".campo").val("");

})